export default "dist/images/block-number-box-heading2.635cc76.png";